import { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Row, Col, Form, Card } from "reactstrap";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import { FormikErrors, useFormik } from "formik";
import { addAttachments } from 'src/slices/Projects/thunk';
import { useDispatch} from "react-redux";
import { AppDispatch } from "src";
import { formatBytes } from 'src/helpers/format_helper';


interface FileUploadModalProps {
    project: any;
    onCloseCallBack: () => void;
}

const FileUploadModal = ({ project, onCloseCallBack }: FileUploadModalProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch<AppDispatch>();
    const [modal, setModal] = useState(false);
    const toggle = () => {
        setselectedFiles([]);
        setModal(!modal);
    }
    const [selectedFiles, setselectedFiles] = useState<File[]>([]);
    
    const form = useFormik({
        initialValues: {
            attachments: [] as File[]
        },
        onSubmit: (values) => {
            setIsLoading(true);
            dispatch(addAttachments({ projectId: project.id, attachments: selectedFiles }))
            .then(() => {
                setIsLoading(false);
                toggle();            
                setselectedFiles([]);
                onCloseCallBack();
            });
        },
        validate: (values) => {
            const errors: FormikErrors<{attachments: File[]}> = {};
            if (selectedFiles.length === 0) {
                errors.attachments = "Por favor, carregue pelo menos um anexo.";
            }   
            return errors;
        },
    });

    useEffect(() => {
        if (isLoading) {
            document.body.style.cursor = 'wait';
        } else {
            document.body.style.cursor = 'default';
        }

        return () => {
            document.body.style.cursor = 'default';
        };
    }, [isLoading]); 

    function handleAcceptedFiles(files: any) {
        files.map((file: any) => Object.assign(file, {
            preview: URL.createObjectURL(file),
            formattedSize: formatBytes(file.size),
        }));        
        setselectedFiles(selectedFiles.concat(files));
    }
    
    return (
        <div>
            <Button color="danger" onClick={toggle}>
                <i className="uil uil-upload-alt"></i>
            </Button>
            <Modal isOpen={modal} toggle={toggle}>
                <Form onSubmit={e => {
                    e.preventDefault();
                    form.handleSubmit();
                    return false;
                }}>
                    <ModalHeader toggle={toggle}>Inserir Anexos</ModalHeader>
                    <ModalBody>
                        <Dropzone
                            onDrop={acceptedFiles => {
                                handleAcceptedFiles(acceptedFiles);
                                //step4.setFieldValue("attachments", acceptedFiles);
                            }}
                        >
                            {({ getRootProps, getInputProps }) => (
                            <div className="dropzone dz-clickable">
                                <div className="dz-message needsclick" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className="mb-3">
                                        <i className="display-4 text-light uil uil-upload-alt"></i>
                                    </div>
                                    <h5 className="font-size-16">
                                        Arraste os ficheiros para aqui ou clique para fazer o upload.
                                    </h5>
                                </div>
                            </div>
                            )}
                        </Dropzone>
                        <div className="dropzone-previews mt-3" id="file-previews">
                            {selectedFiles.map((f: any, i: number) => {
                            return (
                                <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                >
                                    <div className="p-2">
                                        <Row className="align-items-center">
                                        <Col className="col-auto">
                                            <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                            />
                                        </Col>
                                        <Col>
                                            <Link to="#" className="text-muted font-weight-bold">
                                                {f.name}
                                            </Link>
                                            <p className="mb-0">
                                                <strong>{f.formattedSize}</strong>
                                            </p>
                                        </Col>
                                        </Row>
                                    </div>
                                </Card>
                            );
                            })}
                        </div>                    
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" type="submit" disabled={isLoading}>{isLoading ? 'Processando...' : 'Anexar'}</Button>
                        <Button color="secondary" onClick={toggle} disabled={isLoading}>Cancel</Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </div>
    );
}

export default FileUploadModal;